import { pageArgs } from '../common/page-args'
import { isWeixin } from '@/utils/init/wx'

// 微信公共号名称
const YLYKPUBS = [
  'ylsn_pub', // 友邻少年 YLYK
  // 平台已使用的公众号
  'ylsn_pub_test', // 友邻少年 wx1
  // 暴虐新概念
  'ylsn_pub_xsyw' // 夏说英文
]
// const ylykPubDefault = 'ylsn_pub' // 测试公众号
const ylykPubDefault = 'ylsn_pub' // 上线公众号
const hrefIsTest = location.href.indexOf('-test.ylyk.com') >= 0

// 获取微信公众号名称
export const getAccountId = (isBrowser = false) => {
  const { appname, port } = pageArgs.args()
  let accountId = appname // 适配默认公众号

  // 校验公众号有效性
  if (YLYKPUBS.indexOf(accountId) === -1) {
    // 公众号切换需要考虑到APP环境
    if (isWeixin()) {
      const isTest = port.default === 'test' || hrefIsTest
      if (isTest) {
        accountId = 'ylsn_pub' // 测试环境与 app 使用
        // accountId = 'ylsn_pub_old'
      } else {
        accountId = ylykPubDefault
      }
    } else {
      accountId = 'ylsn_web'
    }
  }

  if (location.hash === '#/pullnew' || location.hash === '#/pullnew2023') {
    const isTest =
      port.default === 'test' || location.href.indexOf('/test/') >= 0 || location.href.indexOf('http:') >= 0
    if (isTest) {
      accountId = 'ylsn_pub_test'
      // 测试环境与 app 使用
    } else {
      accountId = 'ylsn_pub_xsrd'
    }
  }
  // 微信环境模拟浏览器登录(为了满足账号切换需求)
  if (isBrowser) {
    accountId = 'ylsn_web'
  }
  console.log(accountId, 'accountId')
  return accountId || ''
}
